import React, { useState, useEffect, useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Navbar as BootstrapNavbar, Container, Nav } from "react-bootstrap";
import axios from "axios";
import "./Navbar.scss";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import { TbMessageChatbotFilled } from "react-icons/tb";

const LANG_OPTIONS = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'fr', label: 'FR', flag: '🇫🇷' },
  { code: 'zh', label: '中文', flag: '🇨🇳' }
];

const Navbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [language, setLanguage] = useState(() => localStorage.getItem('regalbot_lang') || 'en');
  const location = useLocation();
  const { _auth, _setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLanguageChange = async (lang) => {
    if (lang === language) return;
    setLanguage(lang);
    localStorage.setItem('regalbot_lang', lang);
    try {
      if (process.env.REACT_APP_API_URL) {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/set_language`,
          { language: lang },
          { headers: { 'Content-Type': 'application/json' } }
        );
      }
    } catch (err) {
      console.error('Failed to sync language to server:', err);
    }
    window.dispatchEvent(new CustomEvent('regalbot-language-change', { detail: { language: lang } }));
  };

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'regalbot_lang' && e.newValue && e.newValue !== language) {
        setLanguage(e.newValue);
      }
    };
    const onCustom = (e) => {
      if (e.detail?.language && e.detail.language !== language) {
        setLanguage(e.detail.language);
      }
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('regalbot-language-change', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('regalbot-language-change', onCustom);
    };
  }, [language]);

  const handleScroll = () => {
    setScrolling(window.scrollY > 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isBlogActive = location.pathname.startsWith("/blog");

  // Scroll to the top of the page after clicking a link
  const handleNavigationClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0); // Scroll to top after navigating
  };

  return (
    <React.Fragment>
      <BootstrapNavbar
        className={`${scrolling ? "scrolling" : ""}`}
        expand="lg"
        fixed="top"
      >
        <Container>
          <BootstrapNavbar.Brand href="/">
            <img
              src="/images/logo.svg"
              alt="logo"
              width="225px"
              height="auto"
            />
          </BootstrapNavbar.Brand>
          <div className="navbarMenu">
            <BootstrapNavbar.Toggle
              className="customToggle"
              onClick={() => setNavbar(!navbar)}
            />
            <BootstrapNavbar.Collapse>
              <Nav className="ml-auto">
                <BootstrapNavbar.Toggle
                  className="cross"
                  onClick={() => setNavbar(!navbar)}
                />
                <NavLink
                  exact="true"
                  to="/"
                  className="nav-link"
                  activeclassname="active"
                  onClick={() => handleNavigationClick("/")}
                >
                  <span>Home</span>
                </NavLink>
                <NavLink
                  to="/pricing"
                  className="nav-link"
                  activeclassname="active"
                  onClick={() => handleNavigationClick("/pricing")}
                >
                  <span>Pricing</span>
                </NavLink>
                <NavLink
                  to="/contact"
                  className={`nav-link ${isBlogActive ? "active" : ""}`}
                  onClick={() => handleNavigationClick("/contact")}
                >
                  <span>Contact</span>
                </NavLink>

                {/* Chat page */}
                <NavLink to="/workspaces" className="nav-link" onClick={() => handleNavigationClick("/workspaces")}>
                  <span>Workspaces</span>
                </NavLink>
                {_auth && (
                  <NavLink
                    to="/chatbot"
                    className={`chat-link ${isBlogActive ? "active" : ""}`}
                    onClick={() => handleNavigationClick("/chatbot")}
                  >
                    <span>
                      Chatbot
                      <TbMessageChatbotFilled />
                    </span>
                  </NavLink>
                 )}

                <div className="navbar-lang-toggle" role="group" aria-label="Language selection" data-tour="navbar-language">
                  {LANG_OPTIONS.map((opt) => (
                    <button
                      key={opt.code}
                      type="button"
                      className={`navbar-lang-btn ${language === opt.code ? 'active' : ''}`}
                      onClick={() => handleLanguageChange(opt.code)}
                      aria-pressed={language === opt.code}
                      title={opt.label}
                    >
                      <span className="lang-flag" aria-hidden="true">{opt.flag}</span>
                      <span className="lang-label">{opt.label}</span>
                    </button>
                  ))}
                </div>

                <Link
                  to="/login"
                  className={`lap_btn ${
                    window.location.pathname === "/login" ? "active" : ""
                  }`}
                >
                  <button className="booking lap_btn">
                    <span>Login</span>
                  </button>
                </Link>
              </Nav>
            </BootstrapNavbar.Collapse>

            {/* Handle login/logout button for mobile view */}
            <>
              {!_auth ? (
                <button
                  className="booking mbl_btn"
                  onClick={() => handleNavigationClick("/login")}
                >
                  <span>Login</span>
                </button>
              ) : (
                <button
                  className="booking mbl_btn"
                  onClick={() => {
                    localStorage.removeItem("jwt");
                    _setAuth(false);
                    handleNavigationClick("/");
                  }}
                >
                  <span>Logout</span>
                </button>
              )}
            </>
          </div>
        </Container>
      </BootstrapNavbar>
    </React.Fragment>
  );
};

export default Navbar;
